"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaracteristicaValor = void 0;
var CaracteristicaValor = /** @class */ (function () {
    function CaracteristicaValor(_a) {
        var _b = _a.DS_VAL_CARACT, DS_VAL_CARACT = _b === void 0 ? '' : _b, _c = _a.VAL_CARACT, VAL_CARACT = _c === void 0 ? '' : _c;
        this.DS_VAL_CARACT = DS_VAL_CARACT;
        this.VAL_CARACT = VAL_CARACT;
    }
    return CaracteristicaValor;
}());
exports.CaracteristicaValor = CaracteristicaValor;
//# sourceMappingURL=CaracteristicaValor.js.map